import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { ProjectListSidebarSkeleton } from '@jira/platform__skeletons/src/ui/project-list-sidebar/ProjectListSidebarSkeleton.tsx';
import { RecommendationsInProjectListEntryPoint } from '@jira/project-create__projects-directory-templates-sidebar/src/RecommendationsInProjectListEntryPoint.entrypoint.tsx';
import { onboardingRedirectEntryPoint } from '@jira/redirect-entrypoints__onboarding-redirect/src/onboardingRedirectEntryPoint.entrypoint.tsx';
import { projectsDirectoryEntryPoint } from '@jira/spa-apps__directories-projects-v3/src/projectsDirectoryEntryPoint.entrypoint.tsx';
import type { ProjectsDirectoryPageEntryPointType } from './ProjectsDirectoryPageEntryPoint.tsx';

export const CsmProjectsDirectoryPageEntryPoint: ProjectsDirectoryPageEntryPointType =
	createPageEntryPoint({
		main: projectsDirectoryEntryPoint,
		leftSidebar: {
			sidebar: csmAppSidebarEntryPoint,
			isProjectsExpanded: true,
		},
		rightSidebar: RecommendationsInProjectListEntryPoint,
		rightSidebarFallback: ProjectListSidebarSkeleton,
		redirect: onboardingRedirectEntryPoint,
	});
